{
  "page": {
    "title": "Vận chuyển",
    "subtitle": "Quản lý phí vận chuyển, bảng giá nhà vận chuyển, nhà cung cấp & hãng vận chuyển, dải trọng lượng, phương thức giao hàng, báo cáo biên lợi nhuận và lịch sử thay đổi."
  },
  "price": {
    "title": "Bảng giá vận chuyển",
    "subtitle": "Quản lý giá bán theo Dịch vụ (không theo Hãng vận chuyển).",
    "manageServices": "Quản lý dịch vụ",
    "downloadTemplate": "Tải mẫu",
    "export": "Xuất",
    "importExcel": "Nhập Excel",
    "addRateTable": "Thêm bảng giá"
  },
  "rateTable": {
    "title": "Bảng giá nhà vận chuyển",
    "subtitle": "Giá theo vùng (zone) theo nhà cung cấp theo dịch vụ.",
    "accessDenied": {
      "title": "Không có quyền truy cập",
      "body": "Bạn không có quyền xem dữ liệu chi phí (VIEW_FINANCIAL_COST). Vui lòng liên hệ quản trị viên nếu cần truy cập."
    }
  },
  "rateTable2": {
    "page": {
      "title": "Bảng giá vận chuyển — Master-Detail",
      "subtitle": "Quản lý rate theo nhà vận chuyển · so sánh chéo provider",
      "legacyLink": "Xem giao diện cũ"
    },
    "tabs": {
      "rate": "Bảng giá",
      "routing": "Định tuyến",
      "margin": "Báo cáo lợi nhuận",
      "history": "Lịch sử"
    },
    "band": {
      "label": "So sánh tất cả nhà vận chuyển",
      "sub": "Tìm rate rẻ nhất trên mọi provider · LeastCost"
    },
    "panel": {
      "title": "Nhà vận chuyển",
      "inactiveBadge": "Ngưng",
      "meta": "{{carrierCount}} nhà vận chuyển · {{zoneCount}} zone"
    },
    "matrix": {
      "viewDomestic": "Nội địa",
      "viewInbound": "Nhập khẩu",
      "addRate": "Thêm rate",
      "importCsv": "Nhập CSV"
    },
    "empty": {
      "domestic": "Provider này chưa có bảng giá Nội địa",
      "inbound": "Provider này chưa có bảng giá Nhập khẩu",
      "switchHint": "Thử chuyển sang view còn lại"
    },
    "readonly": {
      "banner": "Nhà vận chuyển đã ngưng phục vụ — chỉ xem"
    },
    "navigation": {
      "rt2Routing": "Định tuyến",
      "rt2Margin": "Báo cáo lợi nhuận",
      "rt2History": "Lịch sử",
      "rt2Rate": "Bảng giá"
    },
    "bulk": {
      "bar": "Sửa giá hàng loạt",
      "editPrice": "Sửa giá",
      "selectAll": "Chọn tất cả",
      "applyTo": "Áp dụng cho",
      "newPrice": "Giá mới",
      "confirm": "Xác nhận",
      "cancel": "Hủy",
      "selectedCount": "Đã chọn {{count}}",
      "noTargets": "Không có ô giá nào để cập nhật cho lựa chọn này.",
      "queued": "Đã gửi {{count}} yêu cầu chờ duyệt (quy trình hai cấp)."
    }
  },
  "tabs": {
    "fee": "Phí",
    "rate": "Bảng giá",
    "routing": "Định tuyến",
    "providers": "Nhà cung cấp & Hãng vận chuyển",
    "weightBands": "Dải trọng lượng",
    "methods": "Phương thức",
    "margin": "Báo cáo biên lợi nhuận",
    "history": "Lịch sử"
  },
  "placeholder": {
    "comingSoon": "Đang phát triển",
    "wave7": "Nội dung tab này sẽ được bổ sung ở đợt triển khai tiếp theo."
  },
  "states": {
    "loading": "Đang tải…",
    "empty": "Chưa có dữ liệu.",
    "emptyCta": "Bắt đầu bằng cách thêm bản ghi đầu tiên.",
    "errorTitle": "Không tải được dữ liệu",
    "retry": "Thử lại"
  },
  "approval": {
    "queued": "Đã gửi yêu cầu duyệt",
    "queuedFor": "Thay đổi đang chờ duyệt (quy trình duyệt hai cấp)."
  },
  "fee": {
    "title": "Phí vận chuyển",
    "subtitle": "Quản lý phí thu theo điểm đến, phương thức và dải trọng lượng.",
    "countries": "Quốc gia",
    "zip3Count": "{{count}} mã ZIP3",
    "selectCountryPrompt": "Chọn một quốc gia để xem chi tiết phí theo mã ZIP.",
    "zip3Grid": "Lưới phí ZIP3 — {{country}}",
    "zip5Exceptions": "Ngoại lệ ZIP5",
    "noZip3": "Chưa có phí ZIP3 cho quốc gia này.",
    "noZip5": "Chưa có ngoại lệ ZIP5.",
    "baseFee": "Phí cơ bản (cent)",
    "additionalItemFee": "Phí mỗi sản phẩm thêm (cent)",
    "save": "Lưu",
    "editReason": "Cập nhật phí từ bảng phí vận chuyển",
    "confirmNegativeMargin": "Xác nhận dù lợi nhuận âm",
    "pending": "Chờ duyệt",
    "importCsv": "Nhập CSV",
    "importTitle": "Nhập phí vận chuyển từ CSV"
  },
  "csv": {
    "fileLabel": "Tệp CSV",
    "hint": "Chọn tệp CSV để xem trước trước khi gửi duyệt.",
    "dryRun": "Xem trước",
    "dryRunning": "Đang xem trước…",
    "commit": "Gửi duyệt",
    "committing": "Đang gửi…",
    "close": "Đóng",
    "summary": "Tổng {{total}} dòng — {{ok}} hợp lệ, {{errors}} lỗi.",
    "colRow": "Dòng",
    "colStatus": "Trạng thái",
    "colErrors": "Lỗi",
    "statusOk": "Hợp lệ",
    "statusError": "Lỗi",
    "queuedSummary": "Đã gửi {{count}} dòng chờ duyệt.",
    "deduped": "(Yêu cầu đã tồn tại — bỏ qua trùng lặp.)"
  },
  "deprecate": {
    "title": "Cấu hình phí vận chuyển đã chuyển sang trang Shipping mới",
    "body": "Tab này (v1) sẽ ngừng hoạt động. Vui lòng dùng trang Bảng giá nhà vận chuyển mới để quản lý chi phí và bảng giá vận chuyển.",
    "cta": "Mở trang Bảng giá vận chuyển mới"
  },
  "providers": {
    "filter": {
      "searchPlaceholder": "Tìm theo tên hoặc mã",
      "showDeleted": "Hiện bản ghi đã xóa"
    },
    "col": {
      "name": "Tên",
      "code": "Mã",
      "agency": "Đại lý",
      "credential": "Thông tin xác thực",
      "adapter": "Bộ kết nối giá trực tiếp",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động",
      "deleted": "Đã xóa"
    },
    "actions": {
      "edit": "Sửa",
      "delete": "Xóa",
      "restore": "Khôi phục"
    },
    "agencies": {
      "title": "Đại lý",
      "subtitle": "Gốc của cây Đại lý → Nhà cung cấp → Hãng vận chuyển.",
      "create": "Thêm đại lý",
      "createTitle": "Thêm đại lý",
      "editTitle": "Sửa đại lý"
    },
    "providers": {
      "title": "Nhà cung cấp",
      "subtitle": "Thông tin xác thực API là chỉ-ghi — chỉ hiển thị trạng thái đã/chưa thiết lập.",
      "create": "Thêm nhà cung cấp",
      "createTitle": "Thêm nhà cung cấp",
      "editTitle": "Sửa nhà cung cấp",
      "needAgency": "Hãy tạo đại lý trước khi thêm nhà cung cấp."
    },
    "carriers": {
      "title": "Hãng vận chuyển",
      "subtitle": "Danh mục động — thêm hãng vận chuyển mà không cần đổi code.",
      "create": "Thêm hãng vận chuyển",
      "createTitle": "Thêm hãng vận chuyển",
      "editTitle": "Sửa hãng vận chuyển",
      "adapterYes": "Có",
      "adapterNo": "Không"
    },
    "credential": {
      "label": "Thông tin xác thực API (chỉ-ghi)",
      "statusSet": "Đã thiết lập",
      "statusUnset": "Chưa thiết lập",
      "placeholderSet": "Nhập khóa bí mật mới",
      "placeholderRotate": "Nhập khóa bí mật mới để xoay vòng",
      "help": "Khóa bí mật sẽ không bao giờ hiển thị lại sau khi lưu. Để trống để giữ nguyên thông tin hiện tại.",
      "clear": "Xóa thông tin xác thực đã lưu"
    },
    "matrix": {
      "title": "Bật/tắt Nhà cung cấp – Hãng vận chuyển",
      "subtitle": "Bật một hãng vận chuyển cho nhà cung cấp để định giá đơn hàng mới. Tắt không định tuyến lại các đơn đã chốt.",
      "providerCol": "Nhà cung cấp",
      "enabled": "Đang bật",
      "disabled": "Đang tắt",
      "noLink": "chưa liên kết",
      "empty": "Hãy thêm nhà cung cấp và hãng vận chuyển để quản lý bật/tắt."
    },
    "form": {
      "name": "Tên",
      "code": "Mã",
      "agency": "Đại lý",
      "agencyPlaceholder": "Chọn đại lý",
      "status": "Trạng thái",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "cancel": "Hủy",
      "errName": "Vui lòng nhập tên.",
      "errCode": "Mã phải dài 2–40 ký tự: A–Z, 0–9, _ hoặc -.",
      "errAgency": "Vui lòng chọn đại lý."
    },
    "confirm": {
      "deleteTitle": "Xóa {{name}}?",
      "deleteBody": "Đây là xóa mềm — bản ghi có thể khôi phục. Nếu vẫn đang được tham chiếu, thao tác xóa sẽ bị chặn.",
      "deleteConfirm": "Xóa",
      "cancel": "Hủy"
    },
    "toast": {
      "saved": "Đã lưu",
      "saveFailed": "Không lưu được",
      "deleted": "Đã xóa",
      "deleteFailed": "Không xóa được",
      "restored": "Đã khôi phục",
      "restoreFailed": "Không khôi phục được",
      "toggleSaved": "Đã cập nhật trạng thái",
      "toggleFailed": "Không cập nhật được trạng thái"
    }
  },
  "rate": {
    "matrix": {
      "weightColumn": "Trọng lượng",
      "gramColumn": "Gram (g)",
      "zoneHeader": "Zone {{n}}",
      "emptyCell": "—",
      "empty": "Chưa có rate cho nhà vận chuyển này.",
      "providerFilter": {
        "label": "Lọc theo nhà vận chuyển",
        "all": "Tất cả nhà vận chuyển",
        "selectAll": "Chọn tất cả",
        "deselectAll": "Bỏ chọn tất cả"
      },
      "viewSwitch": {
        "domestic": "Nội địa Mỹ",
        "inbound": "Hàng về Mỹ"
      },
      "inbound": {
        "priceColumn": "Giá flat"
      },
      "invalidRate": "Giá phải là số không âm.",
      "changeReason": "Cập nhật giá vốn tuyến từ bảng giá.",
      "editTitle": "Yêu cầu đổi giá",
      "rateCents": "Giá (cents)",
      "cancel": "Hủy",
      "submitRequest": "Gửi yêu cầu duyệt",
      "weightCol": "Trọng lượng",
      "gramCol": "Gram (g)",
      "providerHeader": "Nhà cung cấp",
      "zoneLabel": "Zone {{n}}",
      "filter": {
        "label": "Lọc nhà cung cấp",
        "all": "Tất cả"
      },
      "view": {
        "label": "Chế độ xem bảng giá",
        "domestic": "US Nội địa",
        "inbound": "US Nhập khẩu"
      },
      "meta": "Ma trận rate theo trọng lượng × zone · USD"
    },
    "override": {
      "pinned": "Đã ghim tuyến.",
      "unpinned": "Đã bỏ ghim.",
      "title": "Ghim tuyến (ưu tiên ghi đè)",
      "provider": "Nhà cung cấp",
      "selectOption": "— Chọn —",
      "destType": "Loại điểm đến",
      "destKey": "Mã điểm đến",
      "destPlaceholder": "ZIP / quốc gia / zone",
      "method": "Phương thức",
      "band": "Khoảng cân nặng",
      "reason": "Lý do ghim",
      "reasonPlaceholder": "Vì sao ghim nhà cung cấp này cho tuyến?",
      "pin": "Ghim nhà cung cấp",
      "selectFirst": "Chọn một nhà cung cấp để ghim.",
      "empty": "Chưa có ghim tuyến nào.",
      "unpin": "Bỏ ghim"
    },
    "noAccess": "Bạn không có quyền xem dữ liệu chi phí.",
    "import": "Nhập CSV",
    "pending": {
      "badge": "Chờ duyệt"
    },
    "preview": {
      "errDest": "Nhập điểm đến (ZIP/quốc gia).",
      "errWeight": "Khối lượng phải là số gram dương.",
      "errMethod": "Chọn phương thức giao hàng.",
      "missingRoute": "Không có tuyến phù hợp cho điểm đến và khối lượng này.",
      "title": "Xem trước chi phí thấp nhất",
      "destination": "Điểm đến",
      "weight": "Khối lượng (g)",
      "method": "Phương thức",
      "methodAny": "— Chọn —",
      "run": "Xem chi phí",
      "cheapest": "Rẻ nhất",
      "pinned": "Đã ghim"
    },
    "providerTab": {
      "empty": "Nhà cung cấp này chưa có bảng giá",
      "label": "Chọn nhà cung cấp vận chuyển"
    },
    "serviceBlock": {
      "heading": "Dịch vụ: {{name}}"
    }
  },
  "errors": {
    "loadFee": "Không tải được bảng phí vận chuyển.",
    "loadRate": "Không tải được bảng giá nhà vận chuyển.",
    "loadProviders": "Không tải được nhà cung cấp.",
    "loadCarriers": "Không tải được hãng vận chuyển.",
    "loadProviderCarriers": "Không tải được liên kết nhà cung cấp - hãng vận chuyển.",
    "loadAgencies": "Không tải được đại lý.",
    "loadWeightBands": "Không tải được dải trọng lượng.",
    "loadMethods": "Không tải được phương thức giao hàng.",
    "loadMethodServiceMaps": "Không tải được ánh xạ dịch vụ.",
    "loadRouteOverrides": "Không tải được ghi đè tuyến.",
    "loadMarginReport": "Không tải được báo cáo biên lợi nhuận.",
    "ratePreview": "Không lấy được bảng xem trước chi phí.",
    "import": "Không xử lý được tệp nhập.",
    "network": "Lỗi kết nối - vui lòng kiểm tra mạng"
  },
  "ratesTab": {
    "toast": {
      "saved": "Đã lưu rate table cho {{name}}",
      "saveFailed": "Không lưu được rate table cho {{name}}"
    },
    "saving": "Đang lưu…",
    "loadError": "Không tải được Shipping Rates.",
    "retry": "Thử lại",
    "empty": "Chưa có shipping category.",
    "intro": "Mỗi shipping category quản lý ma trận 7 zones × 2 speed tiers (tổng 14 cells). Bấm vào hàng để mở/đóng matrix inline.",
    "reasonLabel": "Lý do thay đổi (≥10 ký tự, bắt buộc)"
  },
  "configProvider": {
    "title": "Nhà cung cấp",
    "subtitle": "Quản lý đại lý, nhà cung cấp và bật/tắt cặp Nhà cung cấp–Hãng vận chuyển. Thông tin xác thực (credential) chỉ ghi, không bao giờ hiển thị lại.",
    "agencyTitle": "Đại lý",
    "agencySubtitle": "Đại lý là cấp cha của Nhà cung cấp.",
    "providerTitle": "Nhà cung cấp",
    "providerSubtitle": "Nhà cung cấp thuộc một đại lý; có thông tin xác thực ghi-only.",
    "matrixTitle": "Bật/tắt Nhà cung cấp – Hãng vận chuyển",
    "matrixSubtitle": "Bật/tắt từng cặp Nhà cung cấp–Hãng vận chuyển để định tuyến báo giá.",
    "matrixEmpty": "Cần ít nhất một nhà cung cấp và một hãng vận chuyển.",
    "matrixProviderCol": "Nhà cung cấp",
    "matrixEnabled": "Bật",
    "matrixDisabled": "Tắt",
    "matrixNoLink": "(chưa liên kết)",
    "addAgency": "Thêm đại lý",
    "addProvider": "Thêm nhà cung cấp",
    "needAgency": "Hãy tạo đại lý trước khi thêm nhà cung cấp.",
    "edit": "Sửa",
    "restore": "Khôi phục",
    "delete": "Xóa",
    "cancel": "Hủy",
    "save": "Lưu",
    "create": "Tạo",
    "saving": "Đang lưu…",
    "colName": "Tên",
    "colCode": "Mã",
    "colAgency": "Đại lý",
    "colCredential": "Thông tin xác thực",
    "colStatus": "Trạng thái",
    "colActions": "Thao tác",
    "name": "Tên",
    "code": "Mã",
    "agency": "Đại lý",
    "agencyPlaceholder": "Chọn đại lý",
    "status": "Trạng thái",
    "statusActive": "Hoạt động",
    "statusInactive": "Tạm dừng",
    "statusDeleted": "Đã xóa",
    "credentialSet": "Đã thiết lập",
    "credentialUnset": "Chưa thiết lập",
    "agencyCreateTitle": "Tạo đại lý",
    "agencyEditTitle": "Sửa đại lý",
    "providerCreateTitle": "Tạo nhà cung cấp",
    "providerEditTitle": "Sửa nhà cung cấp",
    "deleteAgencyTitle": "Xóa đại lý",
    "deleteProviderTitle": "Xóa nhà cung cấp",
    "deleteConfirm": "Xóa mục này? Mục đang được tham chiếu sẽ không thể xóa.",
    "errName": "Tên là bắt buộc.",
    "errCode": "Mã phải gồm 2–40 ký tự A–Z, 0–9, _ hoặc -.",
    "errAgency": "Vui lòng chọn đại lý.",
    "saved": "Đã lưu",
    "restored": "Đã khôi phục",
    "deletedToast": "Đã xóa",
    "toggleSaved": "Đã lưu bật/tắt",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "fkRestrict": "Không thể xóa: mục đang được tham chiếu."
  },
  "routes": {
    "title": "Tuyến giao hàng",
    "subtitle": "Quản lý tuyến giao hàng quốc tế và nội địa",
    "add": "Thêm tuyến",
    "searchPlaceholder": "Tìm theo mã, tên…",
    "filterTypeAll": "Tất cả loại",
    "filterOriginAll": "Tất cả điểm đi",
    "filterDestinationAll": "Tất cả điểm đến",
    "colRoute": "TUYẾN",
    "colType": "LOẠI",
    "colCarrier": "HÃNG",
    "colServiceArea": "KHU VỰC",
    "colEstDays": "SỐ NGÀY",
    "colBaseFee": "PHÍ CƠ BẢN",
    "colXBorder": "XUYÊN BIÊN",
    "colStatus": "TRẠNG THÁI",
    "colActions": "THAO TÁC",
    "empty": "Chưa có tuyến giao hàng nào",
    "total": "Tổng: {{count}}",
    "show": "Hiển thị:",
    "edit": "Sửa",
    "delete": "Xóa",
    "cancel": "Hủy",
    "save": "Lưu cấu hình",
    "create": "Tạo tuyến",
    "createTitle": "Cấu hình tuyến giao hàng",
    "editTitle": "Sửa cấu hình tuyến",
    "deleteTitle": "Xóa cấu hình tuyến",
    "deleteConfirm": "Xóa cấu hình định tuyến này? Tuyến không còn cấu hình sẽ quay về chi phí thấp nhất.",
    "destinationType": "Loại điểm đến",
    "destinationKey": "Mã điểm đến",
    "methodId": "Dịch vụ (method)",
    "weightBandId": "Dải trọng lượng",
    "destType": {
      "us_zip5": "US ZIP5",
      "us_zip3": "US ZIP3",
      "country": "Quốc gia",
      "zone": "Khu vực (zone)"
    },
    "saved": "Đã lưu cấu hình định tuyến",
    "deletedToast": "Đã xóa cấu hình tuyến",
    "duplicate": "Tuyến đã có cấu hình định tuyến đang hoạt động.",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "invalidWeights": "Tổng % phải bằng 100.",
    "inactiveProvider": "Nhà cung cấp không hoạt động — không thể phân bổ.",
    "forbidden": "Bạn không có quyền VIEW_FINANCIAL_COST.",
    "split": {
      "title": "Phân bổ % theo nhà cung cấp",
      "subtitle": "Nhập % cho từng nhà cung cấp đang hoạt động. Tổng phải bằng 100.",
      "sumLabel": "Tổng",
      "sumOk": "Tổng = 100 ✓",
      "sumInvalid": "Tổng phải bằng 100 (hiện {{sum}})",
      "noActive": "Chưa có nhà cung cấp (ProviderCarrier) nào đang hoạt động — không thể cấu hình phân bổ %.",
      "weightSuffix": "%",
      "autoTitle": "Trọng số tự động (chỉ xem)",
      "autoSubtitle": "Trọng số được tính từ điểm nhà cung cấp; quản trị viên không chỉnh trực tiếp.",
      "autoStubNote": "TODO(M1-stub): pipeline tính điểm chưa sẵn sàng — đang dùng trọng số chia đều mặc định.",
      "derivedSuffix": "% (tự động)"
    },
    "mode": {
      "label": "Chế độ định tuyến",
      "least_cost": "Chi phí thấp nhất",
      "percent_split": "Phân bổ theo %",
      "auto_score": "Tự động theo điểm",
      "leastCostHint": "Mặc định: chọn nhà cung cấp có giá thấp nhất khi route chưa cấu hình phân bổ.",
      "percentSplitHint": "Phân bổ lưu lượng theo % cho từng nhà cung cấp đang hoạt động; tổng phải bằng 100.",
      "autoScoreHint": "Trọng số được tính tự động từ điểm nhà cung cấp (SLA/lỗi/CS) — chỉ xem, không sửa.",
      "pinOverrideNote": "Lưu ý: route đã ghim (pin-override) sẽ thắng MỌI chế độ định tuyến. Khi không có cấu hình phân bổ, hệ thống quay về chi phí thấp nhất."
    }
  },
  "zone": {
    "title": "Khu vực",
    "subtitle": "Quản lý khu vực theo vị trí kho/xưởng cho định giá chặng cuối (last-mile). Tạo khu vực mới sẽ xuất hiện trong tra cứu giá chặng cuối.",
    "add": "Thêm khu vực",
    "edit": "Sửa",
    "restore": "Khôi phục",
    "delete": "Xóa",
    "cancel": "Hủy",
    "save": "Lưu",
    "create": "Tạo khu vực",
    "createTitle": "Tạo khu vực",
    "editTitle": "Sửa khu vực",
    "deleteTitle": "Xóa khu vực",
    "deleteConfirm": "Xóa khu vực này? Khu vực đang được bảng phí/bảng giá tham chiếu sẽ không thể xóa.",
    "colZone": "Khu vực",
    "colWarehouse": "Vị trí kho",
    "colFactory": "Vị trí xưởng",
    "colLastMile": "Chặng cuối",
    "colStatus": "Trạng thái",
    "colActions": "Thao tác",
    "zoneKey": "Mã khu vực",
    "zoneKeyHint": "Tối đa 40 ký tự, duy nhất.",
    "warehouseLocationKey": "Vị trí kho (origin)",
    "factoryLocationKey": "Vị trí xưởng (tùy chọn)",
    "carrierHint": "Gợi ý hãng vận chuyển (tùy chọn)",
    "lastMileEnabled": "Bật chặng cuối",
    "status": "Trạng thái",
    "statusActive": "Hoạt động",
    "statusInactive": "Tạm dừng",
    "statusDeleted": "Đã xóa",
    "lastMileOn": "Bật",
    "lastMileOff": "Tắt",
    "none": "—",
    "saved": "Đã lưu khu vực",
    "restored": "Đã khôi phục khu vực",
    "deletedToast": "Đã xóa khu vực",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "duplicate": "Mã khu vực đã tồn tại — không thể tạo trùng.",
    "fkRestrict": "Không thể xóa: khu vực đang được bảng phí/bảng giá tham chiếu.",
    "errorValidation": "Dữ liệu không hợp lệ."
  },
  "configCarrier": {
    "title": "Hãng vận chuyển",
    "subtitle": "Quản lý danh bạ hãng vận chuyển (USPS/UPS/FedEx…). Hãng có adapter được hệ thống hỗ trợ báo giá tự động.",
    "add": "Thêm hãng vận chuyển",
    "edit": "Sửa",
    "restore": "Khôi phục",
    "delete": "Xóa",
    "cancel": "Hủy",
    "save": "Lưu",
    "create": "Tạo hãng vận chuyển",
    "createTitle": "Tạo hãng vận chuyển",
    "editTitle": "Sửa hãng vận chuyển",
    "deleteTitle": "Xóa hãng vận chuyển",
    "deleteConfirm": "Xóa hãng vận chuyển này? Hãng đang được tham chiếu sẽ không thể xóa.",
    "colName": "Tên",
    "colCode": "Mã",
    "colAdapter": "Adapter",
    "colStatus": "Trạng thái",
    "colActions": "Thao tác",
    "name": "Tên",
    "code": "Mã",
    "status": "Trạng thái",
    "statusActive": "Hoạt động",
    "statusInactive": "Tạm dừng",
    "statusDeleted": "Đã xóa",
    "adapterYes": "Có adapter",
    "adapterNo": "Không adapter",
    "errName": "Tên là bắt buộc.",
    "errCode": "Mã phải gồm 2–40 ký tự A–Z, 0–9, _ hoặc -.",
    "saved": "Đã lưu hãng vận chuyển",
    "restored": "Đã khôi phục hãng vận chuyển",
    "deletedToast": "Đã xóa hãng vận chuyển",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "fkRestrict": "Không thể xóa: hãng vận chuyển đang được tham chiếu."
  },
  "dutyRate": {
    "title": "Thuế nhập khẩu",
    "subtitle": "Cấu hình thuế nhập khẩu theo khu vực (áp dụng cho đơn của vendor ngoài Mỹ giao đến Mỹ). DDP: nền tảng tính thuế; DDU: người mua tự trả tại hải quan.",
    "colZone": "Khu vực",
    "colPercent": "Thuế suất (%)",
    "colPayer": "Bên trả thuế",
    "colMultiplier": "Hệ số hải quan",
    "colActions": "Thao tác",
    "percent": "Thuế suất nhập khẩu (%)",
    "percentHint": "Từ 0 đến 100.",
    "payer": "Bên trả thuế",
    "payerDDP": "DDP (đã trả thuế khi giao)",
    "payerDDU": "DDU (chưa trả thuế khi giao)",
    "multiplier": "Hệ số hải quan (tùy chọn)",
    "multiplierHint": "Để trống = giữ nguyên giá trị hiện tại.",
    "edit": "Sửa",
    "save": "Lưu",
    "cancel": "Hủy",
    "unset": "Chưa cấu hình",
    "saved": "Đã lưu thuế nhập khẩu",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "forbidden": "Bạn không có quyền xem/sửa thuế nhập khẩu (giá vốn).",
    "errorRange": "Thuế suất phải nằm trong khoảng 0–100.",
    "errorValidation": "Dữ liệu không hợp lệ."
  },
  "methods": {
    "title": "Phương thức giao hàng",
    "subtitle": "Tạo phương thức (luôn ở trạng thái nháp) rồi thêm ít nhất một service map trước khi kích hoạt.",
    "add": "Thêm phương thức",
    "name": "Tên",
    "code": "Mã (A-Z, 0-9, _ -)",
    "colName": "Tên",
    "colCode": "Mã",
    "colStatus": "Trạng thái",
    "colMaps": "Service map",
    "colActions": "Thao tác",
    "statusDraft": "Nháp",
    "statusActive": "Đang hoạt động",
    "statusInactive": "Tạm dừng",
    "deleted": "Đã xóa",
    "activate": "Kích hoạt",
    "deactivate": "Tạm dừng",
    "delete": "Xóa",
    "restore": "Khôi phục",
    "manageMaps": "Service map",
    "addServiceMap": "Thêm service map",
    "providerCarrier": "Nhà cung cấp · Hãng",
    "serviceCode": "Mã dịch vụ (vd: usps_priority)",
    "noMaps": "Chưa có service map. Thêm ít nhất một để kích hoạt phương thức.",
    "mapsCount": "{{count}} service map",
    "saved": "Đã lưu phương thức",
    "activated": "Đã kích hoạt phương thức",
    "deactivated": "Đã tạm dừng phương thức",
    "deletedToast": "Đã xóa phương thức",
    "restored": "Đã khôi phục phương thức",
    "mapSaved": "Đã lưu service map",
    "mapDeleted": "Đã xóa service map",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "cancel": "Hủy",
    "save": "Lưu",
    "close": "Đóng",
    "activateNeedsMap": "Phương thức cần ít nhất một service map để kích hoạt.",
    "lastMapGuard": "Không thể xóa service map cuối cùng của phương thức đang hoạt động.",
    "duplicateMap": "Service map này đã tồn tại.",
    "loadMapsError": "Không tải được service map."
  },
  "weightBands": {
    "title": "Dải trọng lượng",
    "subtitle": "Khoảng nửa mở [min, max) tính theo gam — min bao gồm, max loại trừ. Dải trên cùng không giới hạn (max trống).",
    "add": "Thêm dải",
    "edit": "Sửa",
    "restore": "Khôi phục",
    "delete": "Xóa",
    "colInterval": "Khoảng",
    "colLabel": "Nhãn",
    "colStatus": "Trạng thái",
    "colActions": "Thao tác",
    "minGrams": "Min (gam, bao gồm)",
    "maxGrams": "Max (gam, loại trừ)",
    "maxGramsHint": "Để trống = không giới hạn (dải trên cùng).",
    "label": "Nhãn",
    "unbounded": "Không giới hạn",
    "deleted": "Đã xóa",
    "saved": "Đã lưu khoảng cân nặng",
    "restored": "Đã khôi phục dải trọng lượng",
    "deletedToast": "Đã xóa dải trọng lượng",
    "staleVersion": "Bản ghi đã thay đổi ở nơi khác — đã tải lại, vui lòng thử lại.",
    "cancel": "Hủy",
    "save": "Lưu",
    "errorOverlap": "Các khoảng cân nặng bị chồng lấn.",
    "errorGap": "Các khoảng cân nặng để hở (chưa phủ hết).",
    "errorNoUnbounded": "Phải có đúng một dải không giới hạn (max trống) ở trên cùng.",
    "errorValidation": "Max phải lớn hơn min (khoảng [min, max))."
  },
  "history": {
    "heading": "Lịch sử thay đổi giá / phí vận chuyển",
    "subtitle": "Nhật ký thay đổi bảng giá và phí theo hiệu lực (cũ → mới), kèm người tạo và người duyệt (quy trình duyệt hai cấp).",
    "empty": "Chưa có thay đổi giá / phí vận chuyển nào.",
    "error": "Không tải được lịch sử thay đổi.",
    "view": "Xem chi tiết",
    "col": {
      "effectiveFrom": "Hiệu lực từ",
      "target": "Đối tượng",
      "newValue": "Giá trị mới",
      "status": "Trạng thái",
      "requestedBy": "Người tạo",
      "approvedBy": "Người duyệt"
    },
    "target": {
      "rateCard": "Bảng giá nhà vận chuyển",
      "feeTable": "Bảng phí"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối",
      "expired": "Hết hạn"
    },
    "detail": {
      "title": "Chi tiết thay đổi",
      "close": "Đóng",
      "supersedes": "Thay thế bản ghi",
      "netNew": "Tạo mới (không thay thế)",
      "decidedAt": "Thời điểm quyết định",
      "costRedacted": "Một số trường chi phí đã được ẩn vì bạn không có quyền xem chi phí."
    }
  },
  "margin": {
    "heading": "Báo cáo biên lợi nhuận theo tuyến",
    "subtitle": "Biên lợi nhuận mỗi tuyến = Phí − chi phí thực tế của hãng vận chuyển (tạm dùng ước tính khi chưa mua nhãn).",
    "forbidden": "Bạn không có quyền xem dữ liệu chi phí (VIEW_FINANCIAL_COST).",
    "filterRoute": "Lọc theo loại tuyến",
    "filterAll": "Tất cả tuyến",
    "empty": "Chưa có tuyến nào có chi phí thực để hiển thị biên lợi nhuận.",
    "estimateBadge": "(ước tính)",
    "estimateFallback": "Chưa mua nhãn — đang dùng chi phí ước tính.",
    "varianceExceeded": "Vượt ngưỡng",
    "varianceOk": "Trong ngưỡng",
    "destinationType": {
      "us_zip5": "ZIP 5 số (US)",
      "us_zip3": "ZIP 3 số (US)",
      "country": "Quốc gia",
      "zone": "Vùng"
    },
    "col": {
      "route": "Tuyến",
      "fee": "Phí thu",
      "actualRate": "Chi phí thực",
      "margin": "Biên lợi nhuận",
      "variance": "Chênh lệch",
      "flag": "Cảnh báo"
    }
  },
  "config": {
    "title": "Cấu hình vận chuyển",
    "subtitle": "Quản lý khu vực, hãng vận chuyển, dịch vụ, tuyến giao hàng, thuế nhập khẩu, nhà cung cấp và dải trọng lượng.",
    "tabs": {
      "zone": "Khu vực",
      "carrier": "Hãng vận chuyển",
      "service": "Dịch vụ",
      "shippingRoutes": "Tuyến giao hàng",
      "dutyRate": "Thuế nhập khẩu",
      "provider": "Nhà cung cấp",
      "weightBands": "Dải trọng lượng"
    },
    "service": {
      "title": "Dịch vụ vận chuyển",
      "subtitle": "Quản lý dịch vụ vận chuyển (độc lập với Hãng vận chuyển).",
      "rateTables": "Bảng giá",
      "addService": "+ Thêm dịch vụ"
    },
    "comingSoon": "Đang phát triển",
    "comingSoonHint": "Nội dung tab này sẽ được bổ sung ở đợt triển khai tiếp theo."
  },
  "trackRouting": {
    "title": "Theo dõi vận chuyển",
    "subtitle": "Giám sát hiệu suất SLA và theo dõi tất cả lô hàng",
    "dashboardTitle": "Bảng điều khiển hiệu suất SLA",
    "cards": {
      "on_time_rate": {
        "label": "Tỷ lệ giao đúng hạn",
        "sub": "{{numerator}} / {{denominator}} lô hàng"
      },
      "avg_delivery_days": {
        "label": "Thời gian giao trung bình",
        "sub": "Từ lúc gửi đến lúc giao"
      },
      "delayed": {
        "label": "Trễ hẹn",
        "sub": "Quá hạn giao dự kiến"
      },
      "exceptions": {
        "label": "Sự cố",
        "sub": "Cần xử lý"
      },
      "active_time": {
        "label": "Thời gian hoạt động",
        "sub": "{{count}} lô hàng · TB {{avgHrs}} · tối đa {{maxHrs}}"
      },
      "last_mile_time": {
        "label": "Thời gian chặng cuối",
        "sub": "{{count}} lô hàng · TB {{avgHrs}} · tối đa {{maxHrs}}"
      }
    },
    "statusOverview": {
      "title": "Tổng quan trạng thái lô hàng",
      "delivered": "Đã giao",
      "inTransit": "Đang vận chuyển",
      "pendingPickup": "Chờ lấy hàng",
      "delayed": "Trễ hẹn",
      "exceptions": "Sự cố"
    },
    "alerts": {
      "title": "Cảnh báo lô hàng",
      "summary": "{{critical}} nghiêm trọng, {{warnings}} cảnh báo",
      "empty": "Không có cảnh báo nào.",
      "collapse": "Thu gọn cảnh báo",
      "expand": "Mở rộng cảnh báo",
      "ageDays": "+{{count}} ngày",
      "view": "Xem",
      "openExternal": "Mở liên kết theo dõi",
      "kind": {
        "exception": "Sự cố",
        "sla_at_risk": "Nguy cơ trễ SLA",
        "delayed": "Trễ hẹn"
      }
    },
    "tabs": {
      "all": "Tất cả",
      "in_transit": "Đang vận chuyển",
      "delivered": "Đã giao",
      "delayed": "Trễ hẹn",
      "exceptions": "Sự cố"
    },
    "toolbar": {
      "searchPlaceholder": "Tìm theo mã vận đơn hoặc đơn hàng…",
      "allStatuses": "Tất cả trạng thái",
      "allCarriers": "Tất cả đơn vị vận chuyển"
    },
    "table": {
      "columns": {
        "trackingNumber": "MÃ VẬN ĐƠN",
        "carrier": "ĐƠN VỊ VC",
        "orderRef": "ĐƠN HÀNG",
        "status": "TRẠNG THÁI",
        "shipped": "NGÀY GỬI",
        "estimatedDelivery": "DỰ KIẾN GIAO",
        "firstScan": "QUÉT ĐẦU",
        "delivered": "ĐÃ GIAO",
        "sla": "SLA",
        "actions": "THAO TÁC"
      },
      "status": {
        "delivered": "Đã giao",
        "in_transit": "Đang vận chuyển",
        "out_for_delivery": "Đang giao",
        "label_created": "Đã tạo nhãn",
        "pending_pickup": "Chờ lấy hàng",
        "delayed": "Trễ hẹn",
        "exception": "Sự cố"
      },
      "deliveredPrefix": "Đã giao",
      "delayDays": "+{{count}} ngày trễ",
      "slaDays": "{{count}}n",
      "empty": "Không có lô hàng nào khớp bộ lọc.",
      "notShipped": "—",
      "viewAction": "Xem chi tiết",
      "openExternal": "Mở liên kết theo dõi"
    },
    "pagination": {
      "total": "Tổng: {{count}}",
      "show": "Hiển thị",
      "prev": "Trang trước",
      "next": "Trang sau"
    },
    "window": {
      "7d": "7 ngày",
      "30d": "30 ngày",
      "90d": "90 ngày",
      "aria": "Khoảng thời gian số liệu SLA"
    },
    "actions": {
      "trackingUnavailable": "Không có liên kết theo dõi: mã vận đơn thiếu hoặc không hợp lệ, hoặc đơn vị vận chuyển chưa được hỗ trợ.",
      "detailsUnavailable": "Không có chi tiết đơn hàng: mã đơn hàng thiếu hoặc không hợp lệ."
    },
    "dashboardEmpty": "Không có dữ liệu trong khoảng này"
  },
  "_vgBinding": "vg-binding: P9.2.D-11 P9.2.D-04 P9.2.D-01 P9.2.D-02 P9.2.D-12 — shipping i18n bundles moved from inline .ts to canonical shipping.json: methods/weightBands/history/margin [task-03]; trackRouting (TrackRoutingPage+ShipmentTable) + config (ConfigPage) [task-05]. vg-binding: P4.8.D-06 P4.8.D-22 (G-13) — rateTable2.navigation (CR-1 submenu labels) + rateTable2.bulk (CR-2 bulk-action labels) added across en/vi/fr [task-09]"
}
